import { Box, Grid, Typography } from "@mui/material";
import React from "react";

import PinkButton from "../../components/customButtons/PinkButton";

export default function NewPage404() {
  return (
    <>
      <Grid
        container
        spacing={2}
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        height="100vh"
        width="100%"
      >
        <Box width={548}>
          <img src="/newdashboard/ErrorPageIcons/222650285_97c75db9-87e6-4bd5-a20d-352d153a7da9 (1) 1.svg" />
        </Box>

        <Typography
        mt={2}
          color="#000000"
          fontFamily="Inter"
          fontSize="26px"
          letterSpacing="0px"
          style={{ fontWeight: 700 }}
        >
          {" "}
       Page Not Found
        </Typography>

        <Typography
          color="#000000"
          fontFamily="Inter"
          fontSize="20px"
          mt={2}
          letterSpacing="0px"
          textAlign="center"
          style={{ fontWeight: 400 }}
        >
          {" "}
        Resource not found. The page or item you are looking for does not exist.
        </Typography>

        <Box mt={3}>
          <PinkButton
            buttonTitle="Retry"
            startIcon={<img src="/newdashboard/ErrorPageIcons/fa_repeat.png" />}
          />
        </Box>
      </Grid>
    </>
  );
}
